import { render, staticRenderFns } from "./PaymentModal.vue?vue&type=template&id=5a990444&scoped=true&"
import script from "./PaymentModal.vue?vue&type=script&lang=ts&"
export * from "./PaymentModal.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentModal.vue?vue&type=style&index=0&id=5a990444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a990444",
  null
  
)

export default component.exports